import { h, Component } from 'preact';
import Button from 'components/button/button';

import s from 'components/button/undoRedoButtons.sss';

/**
 * UndoRedoButtons - Toolbar buttons for undo/redo functionality
 *
 * Props:
 *   - manager: The undo/redo manager instance (from utils/undoRedo)
 *   - dark: Boolean for dark theme
 */
export default class UndoRedoButtons extends Component {
	constructor(props) {
		super(props);

		this.state = {
			canUndo: props.manager?.canUndo(),
			canRedo: props.manager?.canRedo(),
		};

		this.undo = this.undo.bind(this);
		this.redo = this.redo.bind(this);
	}

	// Update the state when the canUndo state changes to force a rerender
	componentWillReceiveProps(nextProps) {
		const canUndo = nextProps.manager?.canUndo();
		if (canUndo !== this.state.canUndo) {
			this.setState({ canUndo });
		}
		const canRedo = nextProps.manager?.canRedo();
		if (canRedo !== this.state.canRedo) {
			this.setState({ canRedo });
		}
	}

	// Do not rerender if props nor state have changed
	shouldComponentUpdate(nextProps, nextState) {
		const nextPropsEntries = Object.entries(nextProps);
		if (nextPropsEntries.length !== Object.keys(this.props).length || nextPropsEntries.some(e => this.props[e[0]] !== e[1])) {
			return true;
		}
		const nextStateEntries = Object.entries(nextState);
		if (nextStateEntries.length !== Object.keys(this.state).length || nextStateEntries.some(e => this.state[e[0]] !== e[1])) {
			return true;
		}
		return false;
	}

	undo() {
		this.props.manager?.undo();
	}

	redo() {
		this.props.manager?.redo();
	}

	render(props, state) {
		return (
			<div class={s.wrapper}>
				<Button
					dark={props.dark}
					icon="undo"
					disabled={!props.manager?.canUndo()}
					onClick={this.undo}
				>
					Undo
				</Button>
				<Button
					dark={props.dark}
					icon="redo"
					disabled={!props.manager?.canRedo()}
					onClick={this.redo}
				>
					Redo
				</Button>
			</div>
		);
	}
}
